import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
export function Layout() {
  return <div className="flex min-h-screen bg-light" data-id="element-92">
      <Sidebar data-id="element-93" />
      <main className="flex-1 p-6" data-id="element-94">
        <Outlet data-id="element-95" />
      </main>
    </div>;
}